<template>
  <div class="z-border-red py-3 px-2 ma-1">
    <v-layout wrap>
      <v-flex class="title mb-2">QR Code</v-flex>

      <v-flex shrink class="text-xs-right">
        <v-btn fab outline small color="primary" v-if="!value" @click="$emit('onEdit')">
          <em class="fa fa-pencil-alt middle" />
        </v-btn>
      </v-flex>
    </v-layout>
    <slot name="status"></slot>
    <div class="caption">GB Prime Token</div>
    <div class="form-control" :class="{ 'has-error': errors.has('token') }">
      <template v-if="value">
        <input
          type="text"
          v-model="token"
          v-validate="'required'"
          name="token"
          data-vv-as="Token"
        />
        <span class="text-error" v-if="errors.has('token')">{{ errors.first('token') }}</span>
      </template>
      <div class="primary--text" v-else>
        {{ token ? token : '-' }}
      </div>
    </div>

    <div class="text-xs-center" v-if="value">
      <v-btn color="grey" outline @click="onCancel" v-if="showCancel">
        {{ $t('cancel') }}
      </v-btn>
      <v-btn color="primary" depressed @click="onSave">
        {{ $t('Save') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'gbprime_token', 'showCancel'],
  data() {
    return {
      token: ''
    }
  },
  mounted() {
    this.token = this.gbprime_token
  },
  methods: {
    onCancel() {
      this.$emit('onCancel')
    },
    async onSave() {
      var result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        vm.goToErrorInput()
        return false
      }
      this.$emit('onSave', {
        gbprime_token: this.token
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/GbprimeQrcode.vue